import React from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import { ITEM_TYPE_MAIL } from '@client/components/Editor/settings'

import './styles.scss'

export const EmptyItemPlaceholder = ({
  itemsCount,
  app = AppModelNULL,
  editor = EditorModelNULL,
}) => {
  const { formatMessage } = app
  return (
    <If condition={!itemsCount}>
      <div className="empty-item-placeholder">
        <span className="bp6-icon-standard bp6-icon-envelope" />
        <h1 className="bp6-heading mb2">
          {formatMessage(
            `emptyitemplaceholder.${(
              `${editor.kind}` || ITEM_TYPE_MAIL
            ).toLowerCase()}.header`
          )}
        </h1>
        <p className="bp6-ui-text-large">
          {formatMessage('emptyitemplaceholder.text')}
        </p>
      </div>
    </If>
  )
}

EmptyItemPlaceholder.propTypes = {
  itemsCount: PropTypes.number,
  app: PropTypes.instanceOf(AppModel),
  editor: PropTypes.instanceOf(EditorModel),
}

export default inject('app', 'editor')(observer(EmptyItemPlaceholder))
